export default "__VITE_ASSET__DXeOyMRr__"